'use strict';

namespace ekh {

    interface Campaign {
        Source: string;
        Medium: string;
        Number: string;
    }

    class CampaignTelephoneNumber {

        campaigns: Campaign[];
        telephoneNumber: string;

        constructor(private cookieService:any, private resourceService:any){
            let matchedCampaign:Campaign[] = [];

            this.telephoneNumber = this.resourceService.get('TELEPHONENUMBER');

            const ref = this.cookieService.get('CampaignReferrer');
            if ( ref && ref.includes('_') ) {
                let referrerList = ref.split('_');
                let referrer = {
                    Source: referrerList[0].toLowerCase(),
                    Medium: referrerList[1].toLowerCase()
                };
                matchedCampaign = this.campaigns.filter(function(campaign) {
                    const campSource = campaign.Source.toLowerCase();
                    const referSource = referrer.Source.toLowerCase();
                    const campMedium = campaign.Medium.toLowerCase();
                    const referMedium = referrer.Medium.toLowerCase();
                    return CampaignTelephoneNumber.isMatched(campSource, referSource)
                        && CampaignTelephoneNumber.isMatched(campMedium, referMedium);
                });
            }

            if ( matchedCampaign.length && matchedCampaign[0].Number ) {
                this.telephoneNumber = matchedCampaign[0].Number;
            }
        }

        static isMatched(campVal, referVal): boolean {
            if (campVal === referVal) {
                return true;
            }
            if (campVal.indexOf('%') !== -1) {
                campVal = campVal.replace(/[-\/\\^$*+?.()|\[\]{}]/g, '\\$&');
                campVal = campVal.replace(/%/g, '.*');
                const regEx = new RegExp(`^${campVal}$`);
                return regEx.test(referVal);
            }
            return false;
        }
    }

    angular
        .module('core')
        .directive('campaignTelephoneNumber', (cookieService) => {
            return {
                restrict: 'A',
                replace: true,
                controller: CampaignTelephoneNumber,
                controllerAs: 'tn',
                scope : {},
                bindToController: {
                    campaigns: '=',
                    eventTracker: '@',
                    eventCategory: '@',
                    eventAction: '@',
                    eventLabel: '@',
                },
                template: (element, attrs) => {
                    if (!attrs.eventCategory) {
                        return `
                            <a href="tel:{{ tn.telephoneNumber }}"
                                event-tracker
                                event-category="{{tn.eventCategory}}"
                                event-action="{{tn.eventAction}}"
                                event-label="{{tn.eventLabel}}">{{ tn.telephoneNumber }}</a>`;
                    }
                    return `<a href="tel:{{ tn.telephoneNumber }}">{{ tn.telephoneNumber }}</a>`;
                }
            };
        });

}
